import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AppResponse } from '../app/response';
import { catchError, map } from 'rxjs/operators';
import { ApiPaths } from 'src/app/core/constants/api-paths.enum';
import { environment } from 'src/environments/environment';
import { InterplanReleaseDateData, InterplanReleaseDateDataUi } from './interplan-release-data';

@Injectable({
  providedIn: 'root'
})
export class InterplanReleaseDataService {

  serviceResult:InterplanReleaseDateData[];
  interplanReleaseDateDataUi:InterplanReleaseDateDataUi;

  isInterplanDataFetched = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  getAllUnSynchedInterplanTitles(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getAllUnSynchedInterplanTitles).pipe(
      map((res: AppResponse) => {
        return res;
      })
      // ,
      // catchError((error:HttpErrorResponse) => this.handleError(error))
    );
  }

  syncInterplanReleaseDateToPPSR(payload:any): Observable<any> {
    return this.http.post<any>(environment.apiUrl+ ApiPaths.syncInterplanReleaseDateToPPSR, payload).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  // updateViewFlagForInterplanTitle(): Observable<any> {
  //   return this.http.post<any>(environment.apiUrl+ ApiPaths.updateViewFlagForInterplanTitles, this.interplanReleaseDateDataUi.unViewedIdList).pipe(
  //     map((res: AppResponse) => {
  //       return res;
  //     })
  //   );
  // }


}
